import CustomRenderer from './CustomRenderer'

export default {
  __init__: ['bpmnRenderer'],
  bpmnRenderer: ['type', CustomRenderer]
}
